/**
 * Design Token Provider Component
 * 
 * Wraps the application and applies design tokens based on campaign data.
 * Can be used at the app level or template level.
 */

import React from 'react';
import { connect } from 'react-redux';
import { useDesignTokens } from './useDesignTokens';

// Import the main design tokens CSS
import './index.css';

/**
 * Provider component that applies design tokens
 */
const DesignTokenProvider = ({ campaign, tenantSlug, children }) => {
  // Apply design tokens based on campaign
  useDesignTokens(campaign, tenantSlug);

  return <>{children}</>;
};

/**
 * Connected version that reads campaign from Redux
 */
const mapStateToProps = (state) => ({
  campaign: state.campaignReducer.campaign,
});

export const ConnectedDesignTokenProvider = connect(mapStateToProps)(DesignTokenProvider);

/**
 * HOC to wrap any component with design token support
 */
export const withDesignTokens = (WrappedComponent) => {
  const WithDesignTokens = (props) => {
    const { campaign, ...rest } = props;
    useDesignTokens(campaign);
    return <WrappedComponent {...props} />;
  };

  WithDesignTokens.displayName = `WithDesignTokens(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  
  return WithDesignTokens;
};

export default DesignTokenProvider;

